<div class="popup">
    <div class="part1">
        <p >DELETE CONFIRMATION</p>
    </div>
    <hr>
    <div class="part2">
        <p>Are you sure you want to delete?<span *ngIf="flag"><br>{{message}}</span></p>
        
        <div class="confirmBtn">
            <div class="btn" (click)="onConfirm('yes')">
                YES
            </div>
            <div class="btn" (click)="onConfirm('no')">
                NO
            </div>
        </div>
    </div>
</div>
